import { UserAvatar } from "src/components/Avatar";
import { Talent, TalentExperience } from "src/types";
import { ReactComponent as LocationIcon } from "src/assets/svg/location.svg";
import { ReactComponent as SmsIcon } from "src/assets/svg/sms.svg";
import { ReactComponent as MobileIcon } from "src/assets/svg/mobile.svg";
import { ReactComponent as BriefcaseIcon } from "src/assets/svg/briefcase3.svg";
import { ReactComponent as DollarIcon } from "src/assets/svg/$.svg";
import { ReactComponent as OpenIcon } from "src/assets/svg/open.svg";
import { TalentClass } from "src/classes/models/talent";
import { dateFormat1 } from "src/utils/dates/formats";

const Profile = ({ t }: { t: Talent }) => {
  const { city, User, FreelancerProfileExperiences: exps } = t;
  const { email_id, full_phone } = User;
  const _t = new TalentClass(t);
  const years = _t.yearsText();
  const salary = _t.salaryText();
  const openTo = _t.openToText();
  const skills = _t.primarySkillsNames();

  return (
    <div className=" flex flex-col gap-9">
      <Wrapper className="flex gap-6 ">
        <UserAvatar wrapperClassName={`!w-[56px] !h-[56px]  `} user={t.User} />
        <div className="font-poppins ">
          <p className="font-semibold text-xl">{t.User.full_name}</p>
          <p className="text-base mt-[2px]">{t.Role?.name}</p>
        </div>
      </Wrapper>

      <Wrapper title="Personal Information">
        <div className="grid grid-cols-3 gap-y-9">
          <PTag className="break-all" text1={email_id} text2="Email address" Icon={SmsIcon} />
          {full_phone && <PTag text1={full_phone} text2="Phone Number" Icon={MobileIcon} />}
          {years && <PTag text1={years} text2="Experience of Work" Icon={BriefcaseIcon} />}
          {city && <PTag text1={city} text2="Location" Icon={LocationIcon} />}
          {salary && <PTag text1={salary} text2="Hourly Rate" Icon={DollarIcon} />}
          {openTo && <PTag text1={openTo} text2="Open to" Icon={OpenIcon} />}
        </div>
      </Wrapper>

      {skills?.length > 0 && (
        <Wrapper title="Skills">
          <div className=" flex flex-wrap gap-9">
            {skills.map((s) => (
              <p key={s} className="bg-[#F9F9F9] p-4 rounded-lg font-poppins font-medium text-base">
                {s}
              </p>
            ))}
          </div>
        </Wrapper>
      )}

      {exps?.length > 0 && (
        <Wrapper title="Employment History">
          <div className="flex flex-col gap-9">
            {exps.map((e) => (
              <Employement key={e.id} e={e} />
            ))}
          </div>
        </Wrapper>
      )}
    </div>
  );
};

const Wrapper = ({ children, className = "", title = "" }) => (
  <div className={"w-full bg-white p-6  rounded-2xl " + className}>
    {title && <p className=" font-semibold font-poppins text-xl mb-6">{title}</p>}
    {children}
  </div>
);

const PTag = ({
  text1,
  className = "",
  text2,
  Icon
}: {
  className?: string;
  text1: string;
  text2: string;
  Icon: typeof LocationIcon;
}) => (
  <div className="flex gap-3">
    <Icon className="w-8 h-8 fill-odfblue shrink-0" />
    <div>
      <p className={"font-poppins font-semibold text-lg " + className}>{text1}</p>
      <p className="font-poppins text-[#8A8A8A] text-base">{text2}</p>
    </div>
  </div>
);

const Employement = ({ e }: { e: TalentExperience }) => (
  <div className=" font-poppins">
    <p className=" text-lg font-semibold">{e.company_name}</p>
    <p className=" text-base font-medium">{e.position}</p>
    <p className="text-base font-medium text-[#8A8A8A]">
      {dateFormat1(e.start_date)} - {e.end_date ? dateFormat1(e.end_date) : "Present"}
    </p>
    <ol className="mt-2 leading-8 text-base w-full ">
      {JSON.parse(e.summary)?.map((duty, i) => <li key={i}>{duty}</li>)}
    </ol>
  </div>
);

export default Profile;
